/*
 *
 * AmlPopup
 *
 * @version 1.0.0
 * @author Minozzi Elia
 * @since 30-Giu-2025
*/

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import ConsentsPopup from './ConsentsPopup'
// import { nullSafe } from 'Utility/globalMethods'
import * as TriggerTimelineActions from 'Store/actions/triggerTimeline'
import { doUpdateConsentsList } from 'Route/Homepage/modules/HomepageActions'

const mapDispatchToProps = dispatch => ({
  ...bindActionCreators(TriggerTimelineActions, dispatch),
  updateConsents: (payload) => dispatch(doUpdateConsentsList(payload))
})

const mapStateToProps = () => ({
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(ConsentsPopup)
